import { render, staticRenderFns } from "./ProductMainComponent.vue?vue&type=template&id=b513db48"
import script from "./ProductMainComponent.vue?vue&type=script&lang=js"
export * from "./ProductMainComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports